module.exports = __webpack_public_path__ + "img/stocks-house-logo.985e9e28.svg";